module.exports = __webpack_public_path__ + "img/arcanjo.3bf6d6f6.jpg";